type ValidationRule<V> = {
  name: string;
  validate(value: V): boolean;
  errorMessage: string;
};

type ValidationResult<V> = {
  isValid: boolean;
  errorMessage: string;
  ruleName: string | undefined;
  value: V;
};

export class Validator<V> {
  private rules: ValidationRule<V>[] = [];

  addRule(rule: ValidationRule<V>) {
    this.rules.push(rule);
  }

  // read your implementation as "shoud be ..."
  validate(value: V): ValidationResult<V> {
    for (const rule of this.rules) {
      if (!rule.validate(value)) {
        return {
          isValid: false,
          errorMessage: rule.errorMessage,
          ruleName: rule.name,
          value,
        };
      }
    }

    return {
      isValid: true,
      value,
      errorMessage: "",
      ruleName: undefined,
    };
  }
}
